import { BanknoteIcon } from 'lucide-react';
import type { Snap } from '@/types/database.types';
import BaseSnapCard from './BaseSnapCard';
import { Link } from 'react-router-dom';

interface CashSnapCardProps {
  snap: Snap & { activity: 'hot' | 'trending' | null };
  onDelete: (id: string) => void;
  onLike: (id: string, event: React.MouseEvent) => void;
  onVote?: (snapId: string, optionId: string) => void;
  onRemoveVote?: (snapId: string) => void;
  isVoting?: boolean;
}

export default function CashSnapCard({ snap, onDelete, onLike, onVote, onRemoveVote, isVoting }: CashSnapCardProps) {
  return (
    <>
      <style>
        {`
          @keyframes cashsnap-glow {
            0% { background-position: 0% 50%; }
            100% { background-position: 200% 50%; }
          }
          .cashsnap-glow::before {
            content: '';
            position: absolute;
            top: -4px;
            left: 0;
            width: 100%;
            height: 6px;
            background: linear-gradient(90deg,
              #ffd700, #ffcc00, #ffff00, #ffcc00, #ffd700);
            background-size: 200% 100%;
            box-shadow: 0 0 25px rgba(255, 215, 0, 0.8), 0 0 30px rgba(255, 204, 0, 0.7);
            border-radius: 12px 12px 0 0;
            animation: cashsnap-glow 2.5s linear infinite;
            filter: blur(4px);
            opacity: 0.95;
          }
          
          .cashsnap-badge {
            position: absolute;
            top: 10px;
            right: 5px;
            width: 40px;
            height: 40px;
            z-index: 10;
            transform-origin: center;
            animation: cashsnap-badge-pulse 1s ease-in-out infinite;
          }
          
          @keyframes cashsnap-badge-pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      <div className="relative">
        <BaseSnapCard
          snap={snap}
          onDelete={onDelete}
          onLike={onLike}
          onVote={onVote}
          onRemoveVote={onRemoveVote}
          isVoting={isVoting}
          wrapperClassName="bg-gradient-to-br from-yellow-50 to-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 overflow-hidden cursor-pointer relative border-2 border-yellow-200 cashsnap-glow h-full flex flex-col"
          badges={
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
              <BanknoteIcon className="h-3.5 w-3.5 mr-1" />
              CASHSNAP
            </span>
          }
        />
        <Link to="/cashsnaps">
          <img 
            src="/cashsnap_min.png" 
            alt="CashSnap" 
            className="cashsnap-badge"
          />
        </Link>
      </div>
    </>
  );
}